<template>
    <div class="biz-upload-video">
        <div class="image-content">
            <label class="button-font input-label">
                <div class="title">
                    <span class="must-fill"></span>
                    廣告影片
                </div>
            </label>
            <div class="has-video" v-if="video.length || videoArray.length">
                <div class="list">
                    <div v-for="(film, index) in videoArray" :key="index" class="item">
                        <div class="video" :class="{'yellow': film.filmStatus === 'UNDER_REVIEW', 'blue': film.filmStatus === 'NORMAL', 'red': film.filmStatus === 'REJECT'}">
                            <div class="name">
                                {{film.filmName}}
                            </div>
                            <div v-if="film.filmStatus === 'UNDER_REVIEW' " class="status yellow">
                                審核中
                            </div>
                            <div v-else-if="film.filmStatus === 'NORMAL' " class="status blue">
                                審核通過
                            </div>
                            <div v-else-if="film.filmStatus === 'REJECT' " class="status red">
                                {{film.rejectReason}}
                            </div>
                        </div>
                        <checkbox msg="公開影片" :val="true" v-model="film.isPublic" :isPropDisabled="film.filmStatus === 'NORMAL'?false:true" :isPropChecked="film.isPublic"></checkbox>
                        <div class="btn-group">
                            <button v-if="film.filmStatus === 'NORMAL'" class="border-button-gray" @click="preview(film.filmId)">預覽影片</button>
                            <file-upload
                                v-if="film.filmStatus === 'REJECT' || film.filmStatus === 'NORMAL' && video.length === 0 && !hasUnderReview && !hasOtherReject"
                                class="border-button-gray"
                                post-action="/upload/post"
                                input-id="re-upload"
                                :size="1024 * 20"
                                :maximum="1"
                                :multiple="true"
                                :drop="true"
                                :drop-directory="true"
                                v-model="video"
                                @input-file="inputFile"
                                @input-filter="inputFilter"
                                ref="uploadCover">
                                    重新上傳
                            </file-upload>
                        </div>
                    </div>
                    <div v-if="video.length" class="item">
                        <div class="video gray">
                            <div class="name">
                                {{videoName}}
                            </div>
                            <div class="status gray">
                                待審核
                            </div>
                        </div>
                        <checkbox msg="公開影片" :val="true" v-model="isPublic" :isPropDisabled="true" :isPropChecked="false"></checkbox>
                        <div class="btn-group">
                            <button class="border-button-gray" @click="preview()">預覽影片</button>
                            <file-upload
                                class="border-button-gray"
                                post-action="/upload/post"
                                input-id="re-upload"
                                :size="1024 * 20"
                                :maximum="1"
                                :multiple="true"
                                :drop="true"
                                :drop-directory="true"
                                v-model="video"
                                @input-file="inputFile"
                                @input-filter="inputFilter"
                                ref="uploadCover">
                                    重新上傳
                            </file-upload>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div v-else class="no-video" >
                <file-upload
                input-id="video"
                class="upload-btn"
                post-action="/upload/post"
                :size="1024 * 20"
                :maximum="1"
                :multiple="true"
                :drop="true"
                :drop-directory="true"
                v-model="video"
                @input-file="inputFile"
                @input-filter="inputFilter"
                ref="upload-vedio">
                    <img class="upload-icon" src="@/assets/img/icon/upload.svg" alt="">
                    <span class="upload-description">拖放檔案或點擊此區立即上傳</span>
                    <span class="upload-drop-alarm">將圖片拖放到這裡</span>
                </file-upload>
            </div>
        </div>
    </div>
</template>
<script>
import FileUpload from 'vue-upload-component';
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';

export default {
    data() {
        return{
            video: [],
        }
    },
    props: {
        isEdit: false,
        normalFilm: null,
        lastFilm: null
    },
    watch: {
        video: function (val){
            if(this.isEdit){
                this.$store.dispatch('setEditVideo', val)

            }else{
                this.$store.dispatch('setVideo', val)
            }
        },
        normalFilm: {
            handler: function (val){
                this.$emit('setVideoInfo', this.normalFilm)
            },
            immediate: true,
            deep: true
        } 
    },
    methods: {
        preview: function (filmId){
            if(this.isEdit && filmId){
                const url = 'https://www.youtube.com/watch?v='+filmId
                window.open(url);
            }else{
                const url = this.video[0].blob
                window.open(url);
            }
            
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(mov|mp4|wmv|avi|mkv|oog)$/i.test(newFile.name)) {
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '請上傳mov、mp4、wmv、avi、mkv、oog 格式影片',type: 'error'})
                    return prevent()
                }
                if(newFile.size > (1024*1024*20)){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '檔案最大限制20MB',type: 'error'})
                    return prevent()
                }
            }
            // console.log(newFile)
            
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
    },
    computed: {
        videoName: function () {
            if(!this.video.length) return
            return this.video[0].name
        },
        videoArray: function () {
            let arr = []

            this.normalFilm?arr.push(this.normalFilm):false
            if(!this.video.length){
                this.lastFilm?arr.push(this.lastFilm):false
            }
            return arr
        },
        hasUnderReview: function () {
            let flag = false
            this.videoArray.forEach(element => {
                if(element.filmStatus === 'UNDER_REVIEW'){
                    flag = true
                }
            });

            return flag
        },
        // 重傳影片有失敗，第一個影片不能顯示重新上傳
        hasOtherReject: function () {
            let flag = false
            this.videoArray.forEach(element => {
                if(element.filmStatus === 'REJECT' && this.videoArray.length === 2){
                    flag = true
                }
            });

            return flag
        },
    },
    components: {
        FileUpload,
        Checkbox
    }
}
</script>
<style lang="scss" scoped>
.biz-upload-video{
    position: relative;
    .no-video.error{
        border: dashed 1px#F05A3E;
    }
    .upload-btn{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .has-video{
        width: 1154px;
        border-radius: 4px;
        box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
        border: solid 1px #f3f3f3;
        background-color: #ffffff;
        padding: 20px 24px;
        box-sizing: border-box;
        .list{
            .item{
                display: flex;
                align-items: center;
                margin-bottom: 16px;
                .video{
                    position: relative;
                    width: 722px;
                    height: 44px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 16px;
                    margin-right: 12px;
                    box-sizing: border-box;
                        border-radius: 1px;
                    &.gray{
                        background-color: #fafafa
                    }
                    &.blue{
                        background-color: rgba(113, 170, 229, 0.1);
                    }
                    &.red{
                        background-color: rgba(255, 146, 117, 0.1);
                    }
                    &.yellow{
                        background-color: #fff9f1;
                    }
                    .status{
                        &.gray{
                            color: #a09896
                        }
                        &.blue{
                            color: #71aae5;
                        }
                        &.red{
                            color: #fc7171;
                        }
                        &.yellow{
                            color: #ff9275;
                        }
                    }
                }
                .checkbox{
                    margin-right: 24px;
                }
                .btn-group{
                    width: 250px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .border-button-gray{
                        width: 120px;
                        height: 44px;
                        box-sizing: border-box;
                    }
                }
                
            }
        }
    }
    .no-video{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 1094px;
        height: 166px;
        margin-bottom: 30px;
        border-radius: 2px;
        border: dashed 1px #cacfcd;
        background-color: #ffffff;
        box-sizing: border-box;
        .upload-icon{
            margin-bottom: 20px;
        }
        .upload-warm{
            margin-top: 10px;
            color: #a8a5a4;
        }
        .upload-drop-alarm{
            display: none;
        }
    }
    .no-video.drop-active{
        border: solid 1px #ff9275;
        background-color: #fff4f1;
        .upload-btn,
        .upload-icon,
        .upload-description,
        .upload-warm{
            display: none;
        }
        .upload-drop-alarm{
            display: block;
            font-weight: 500;
            color: #ff9275;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/houseManagement/addHouse/uploadVideo.vue